<mat-expansion-panel class="exp" [expanded]="status">
    <mat-expansion-panel-header>

    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
        <div *ngFor="let notification of notifications; let i = index">
            <ul>
                <li class="content-box">
                    <div class="col-10">
                        <p>
                            <mat-icon aria-hidden="false" aria-label="notifications">notifications</mat-icon> 
                            {{ notification.text }}
                        </p>
                    </div>
                    <div class="col-2 text-right">
                        <button class="button-secondary-notification icon-delete" (click)="markAsRead(notification.id, i)">{{ 'stt.modalNoti.close' | translate }}</button>
                    </div>
                </li>
            </ul>
        </div>
    </ng-template>
</mat-expansion-panel>
